import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Helmet from "react-helmet"
import "tippy.js/dist/tippy.css";
import "./App.css";

/***************************************************************************
 * CUSTOM HOOK: useDarkMode
 ***************************************************************************/
function useDarkMode() {
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem("theme") === "dark");
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);
  return [darkMode, setDarkMode];
}


/***************************************************************************
 * MAIN COMPONENT: Vizzy
 * - Uses timelineData (null by default) to decide whether to display the form or timeline.
 ***************************************************************************/
export default function Vizzy() {
  const [darkMode, setDarkMode] = useDarkMode();

  return (
    <div className={`flex flex-col items-center justify-center min-h-[100dvh] mx-auto bg-[#dad8d2]/70 dark:bg-[#1f1f1f] transition`}>
      <div className="w-full max-w-[600px] p-4">
        <div className="flex flex-row items-center justify-between mb-8">
          <div className="flex flex-row items-center gap-x-4 text-[#222]/40 dark:text-gray-500">
            <Link to="/" className="font-ubuntu text-xl cursor-pointer">
              vizzy.life
            </Link>
            <button
              className="text-[#222]/40 dark:text-gray-500 transition"
              onClick={() => setDarkMode(!darkMode)}
            >
              {!darkMode ? (
                <div className="flex flex-row items-center gap-x-4">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-5">
                    <path
                      fillRule="evenodd"
                      d="M7.455 2.004a.75.75 0 0 1 .26.77 7 7 0 0 0 9.958 7.967.75.75 0 0 1 1.067.853A8.5 8.5 0 1 1 6.647 1.921a.75.75 0 0 1 .808.083Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              ) : (
                <div className="flex flex-row items-center gap-x-4">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-5">
                    <path d="M10 2a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 2ZM10 15a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5A.75.75 0 0 1 10 15ZM10 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM15.657 5.404a.75.75 0 1 0-1.06-1.06l-1.061 1.06a.75.75 0 0 0 1.06 1.06l1.06-1.06ZM6.464 14.596a.75.75 0 1 0-1.06-1.06l-1.06 1.06a.75.75 0 0 0 1.06 1.06l1.06-1.06ZM18 10a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5A.75.75 0 0 1 18 10ZM5 10a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1 0-1.5h1.5A.75.75 0 0 1 5 10ZM14.596 15.657a.75.75 0 0 0 1.06-1.06l-1.06-1.061a.75.75 0 1 0-1.06 1.06l1.06 1.06ZM5.404 6.464a.75.75 0 0 0 1.06-1.06l-1.06-1.06a.75.75 0 1 0-1.061 1.06l1.06 1.06Z" />
                  </svg>
                </div>
              )}
            </button>
            <a href="https://ko-fi.com/joseph_dev" className="font-ubuntu text-xl text-[#222]/40 dark:text-gray-500 transition">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="size-5">
                <path d="m9.653 16.915-.005-.003-.019-.01a20.759 20.759 0 0 1-1.162-.682 22.045 22.045 0 0 1-2.582-1.9C4.045 12.733 2 10.352 2 7.5a4.5 4.5 0 0 1 8-2.828A4.5 4.5 0 0 1 18 7.5c0 2.852-2.044 5.233-3.885 6.82a22.049 22.049 0 0 1-3.744 2.582l-.019.01-.005.003h-.002a.739.739 0 0 1-.69.001l-.002-.001Z" />
              </svg>
            </a>
          </div>
          <Link to="/create" className="font-ubuntu text-xl mb-2 text-[#222]/40 dark:text-gray-500 transition">
            create my own
          </Link>
        </div>

        <div className="text-[#222]/90 dark:text-white/70 transition">
          <ul className="list-disc pl-4 space-y-2 font-ubuntu">
            <li>Visualise your own life with natural language</li>
            <li>A shareable URL link &mdash; vizzy.life/yourname</li>
            <li>Include your startup achievements with links</li>
            <li>& more, probably</li>
          </ul>

          <div className="mt-8 mb-2">Submit your email and we'll let you know as soon as it's ready!</div>
          <div id="getWaitlistContainer" data-waitlist_id="25264" data-widget_type="WIDGET_2"></div>
          <Helmet>
            <link rel="stylesheet" type="text/css" href="https://prod-waitlist-widget.s3.us-east-2.amazonaws.com/getwaitlist.min.css" />
            <script src="https://prod-waitlist-widget.s3.us-east-2.amazonaws.com/getwaitlist.min.js"></script>
          </Helmet>
        </div>


      </div>
    </div>
  );
}
